// --- NEW FILE: apps/website/src/stores/ui/projectEditor.slice.ts ---

import type { StateCreator } from 'zustand';
import type { Project } from '@dopomogai/types';
import { NEW_PROJECT_TEMPLATE } from './templates';

export interface ProjectEditorState {
  isOpen: boolean;
  editingProject: Project | null;
}

export interface ProjectEditorSlice {
  projectEditor: ProjectEditorState;
  openProjectEditor: (project: Project | null) => void;
  closeProjectEditor: () => void;
  updateEditingProject: (data: Partial<Omit<Project, 'id'>>) => void;
}

export const createProjectEditorSlice: StateCreator<ProjectEditorSlice, [], [], ProjectEditorSlice> = (set) => ({
  projectEditor: {
    isOpen: false,
    editingProject: null,
  },
  openProjectEditor: (project) => set({
    projectEditor: {
      isOpen: true,
      editingProject: project ? { ...project } : { ...NEW_PROJECT_TEMPLATE },
    }
  }),
  closeProjectEditor: () => set({ projectEditor: { isOpen: false, editingProject: null } }),
  updateEditingProject: (data) => set((state) => {
    if (!state.projectEditor.editingProject) return state;
    return {
      projectEditor: {
        ...state.projectEditor,
        editingProject: { ...state.projectEditor.editingProject, ...data },
      }
    };
  }),
});